export default __webpack_public_path__ + "static/media/discover.9601fede.svg";